module.exports = __webpack_public_path__ + "static/media/icon-social-paid.5d802741.svg";